// extracted by mini-css-extract-plugin
module.exports = {"list":"StatusList_list__Byr6l","labelItem":"StatusList_labelItem__Sf9Vu","checkbox":"StatusList_checkbox__27V5R"};